import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export interface Tab {
  label: string;
  value: string;
  quantity?: number;
  icon?: string;
  url?: string;
}

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent {
  @Input() size: 'sm' | 'base' = 'base';
  @Input() translatePrefix = '';
  @Input() type: 'underline' | 'pill' | 'pill-outlined' = 'underline';
  @Input({ required: true }) tabActive: Tab;
  @Input({ required: true }) tabs: Tab[] = [];
  @Output() onTabChange = new EventEmitter<Tab>();
  @Output() tabActiveChange = new EventEmitter<Tab>();

  onClickTab(tab: Tab) {
    this.tabActive = tab;
    this.tabActiveChange.emit(this.tabActive);
    this.onTabChange.emit(tab);
  }

  getContainerClasses(): string {
    return (this.type === 'underline'
      ? this.size === 'sm'
        ? 'h-11'
        : 'h-13'
      : this.type === 'pill' 
        ? 'h-9 bg-neutral-200 p-1 w-full rounded-sm'
        : 'h-11 bg-white p-1 w-full rounded-sm') +  ' overflow-auto';
  }

  getTabClasses(tab: Tab): string {
    const baseClasses = 'h-full flex items-center justify-center cursor-pointer gap-2';

    if (this.type === 'underline') {
      const isActive = tab.value === this.tabActive.value;
      return `${baseClasses} ${this.size === 'sm' ? 'px-3' : 'px-5'} border-b-2 font-medium ${
        isActive ? 'text-blue-600 border-blue-600' : 'border-transparent'
      }`;
    } else if (this.type === 'pill') {
      const isActive = tab.value === this.tabActive.value;
      return `${baseClasses} px-3 rounded ${isActive ? 'bg-white shadow text-blue-600' : ''}`;
    } else {
      const isActive = tab.value === this.tabActive.value;
      return `${baseClasses} px-3 rounded ${isActive ? 'bg-neutral-200 text-neutral-1000' : 'text-neutral-600'}`;
    }
  }

  getQuantityBadgeClasses(tab: Tab): string {
    const baseClasses = 'px-1.5 h-5 rounded-sm flex items-center justify-center font-medium text-2';
    const isActive = tab.value === this.tabActive.value;

    return `${baseClasses} ${isActive ? 'text-white bg-blue-600' : 'text-neutral-800 bg-neutral-300'}`;
  }
}
